module.exports = __webpack_public_path__ + "img/like.53ccfa53.svg";